import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletTransportCreationProfileModule } from './action-tablet-transport-creation-profile/action-tablet-transport-creation-profile.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ActionTabletTransportCreationProfileModule
  ]
})
export class MasterdataModule { }
